module.exports = __webpack_public_path__ + "img/258-mongolia.e7cf2ce7.svg";